/* PDP "Explore more" (Figma), mobile only. Loaded from sections/main-product.liquid.
   The hashtag chips (a.collection-tag-pdp -> /collections/<handle>) become filters: a "Similar Products" chip is
   added and a product grid is shown under the chips. Tapping a hashtag shows that collection's products in place instead of
   navigating (the hrefs stay for no-JS/SEO). Data: /collections/<handle>/products.json (public storefront JSON).
   Wishlist hearts reuse the existing markup/handlers (assets/wishlist.js delegates on .ct_hart_icon_main). */
(function () {
  'use strict';
  var box = document.querySelector('.explpre-collections-container');
  if (!box) return;

  if (!window.matchMedia('(max-width: 767px)').matches) return;
  var content = box.querySelector('.collection-content');
  var tagLinks = content ? Array.prototype.slice.call(content.querySelectorAll('a.collection-tag-pdp')) : [];
  if (!tagLinks.length) return;

  var currentId = String(box.getAttribute('data-product-id') || '');
  var sku = String(box.getAttribute('data-sku') || '').trim();
  var apiBase = window.apiUrl || box.getAttribute('data-api-base') || 'https://middleware.technoboost.in/api/v1';
  var PER_COLLECTION = 8;
  var MAX_SHOWN = 8;
  var cache = {};
  var similarCache;

  var el = function (tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  };
  var handleOf = function (a) {
    var m = /^\/collections\/([^/?#]+)/.exec(a.getAttribute('href') || '');
    return m ? m[1] : '';
  };
  var money = function (n) {
    return '₹' + Number(n).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  };
  var imageUrl = function (u, w) {
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  };

  // Same tag -> badge rules as the PLP card (snippets/product-block.liquid)
  var badgeOf = function (p) {
    var tags = (p.tags || []).map(function (t) {
      return String(t).toLowerCase();
    });
    var has = function (t) {
      return tags.indexOf(t.toLowerCase()) > -1;
    };
    if (has('New Arrival') || String(p.title || '').indexOf('183') > -1) return 'New Arrival';
    if (has('BS March')) return 'Bestseller';
    if (has('SF March')) return 'Selling Fast';
    if (has('TN March')) return 'Trending Now';
    if (has('EE Handpicked') || has('Bridal_handpicked')) return 'Handpicked';
    return '';
  };

  var localWishlistIds = function () {
    if (typeof getLocalWishlistVariantIds === 'function') {
      try {
        return getLocalWishlistVariantIds();
      } catch (e) {}
    }
    try {
      var raw = JSON.parse(localStorage.getItem('local_wish_prod_data') || '[]');
      return Array.isArray(raw) ? raw.map(String) : [];
    } catch (e2) {
      return [];
    }
  };

  var heart = function (p, v, image) {
    var wrap = el('div', 'ct_hart_icon_main');
    var media = el('div', 'ct_hart_icon ct_hart_icon-media');
    var main = el('div', 'wishlist_img_main');
    var attrs = {
      'data-prod-sku': v.sku || '',
      'data-prod-id': p.id,
      'data-prod-type': p.product_type || '',
      'data-prod-metafiled-type': '',
      'data-prod-title': p.title,
      'data-prod-featured-image': image,
      'data-prod-variant-id': v.id,
      'data-prod-price': v.price,
      'data-prod-selling-price': v.compare_at_price || '',
      'data-url': location.origin + '/products/' + p.handle
    };
    Object.keys(attrs).forEach(function (k) {
      main.setAttribute(k, attrs[k]);
    });
    var blank = document.createElement('img');
    blank.className = 'wish_uncheck wishlist_blank_icon';
    blank.width = 30;
    blank.height = 30;
    blank.loading = 'lazy';
    blank.alt = '';
    blank.src = 'https://cdn.shopify.com/s/files/1/0796/1959/files/wish_uncheck.webp?v=1734585398';
    var fill = document.createElement('img');
    fill.className = 'wish_fill wishlist_fill_icon';
    fill.width = 30;
    fill.height = 30;
    fill.loading = 'lazy';
    fill.alt = '';
    fill.src = 'https://cdn.shopify.com/s/files/1/0796/1959/files/wish_fill.png';
    main.appendChild(blank);
    main.appendChild(fill);
    media.appendChild(main);
    wrap.appendChild(media);
    var added = el('div', 'wish_added');
    added.style.display = 'none';
    added.appendChild(el('h2', null, 'Added To Wishlist'));
    var removed = el('div', 'rb_wish_remove');
    removed.style.display = 'none';
    removed.appendChild(el('h2', null, 'Removed From Wishlist'));
    wrap.appendChild(added);
    wrap.appendChild(removed);
    return wrap;
  };

  // Fallback tile only (used per product when the real card fetch below fails). The grid now
  // renders the REAL PLP card (snippets/product-block.liquid) per product via fetchCard(), so
  // Explore more matches the collection grid / Similar designs / Recently Viewed exactly
  // (user: "Similar designs product tile should be same as explore more, all same as PLP").
  var card = function (p) {
    var v = (p.variants && p.variants[0]) || null;
    if (!v || !p.handle) return null;
    var url = '/products/' + encodeURI(p.handle);
    var src = p.images && p.images[0] ? p.images[0].src : '';
    var c = el('div', 'pdp-explore__card');

    var link = el('a', 'pdp-explore__link');
    link.href = url;
    var box2 = el('span', 'pdp-explore__img');
    if (src) {
      var img = document.createElement('img');
      img.loading = 'lazy';
      img.alt = '';
      img.src = imageUrl(src, 500);
      box2.appendChild(img);
    }
    link.appendChild(box2);
    var badge = badgeOf(p);
    if (badge) link.appendChild(el('span', 'pdp-explore__badge', badge));
    c.appendChild(link);

    c.appendChild(heart(p, v, imageUrl(src, 300)));

    var name = el('a', 'pdp-explore__name', p.title);
    name.href = url;
    c.appendChild(name);

    var price = Number(v.price);
    var compare = Number(v.compare_at_price);
    var row = el('div', 'pdp-explore__price');
    row.appendChild(el('b', null, money(price)));
    if (compare > price) {
      row.appendChild(el('s', null, money(compare)));
      row.appendChild(el('em', null, Math.round(((compare - price) / compare) * 100) + '% OFF'));
    }
    c.appendChild(row);
    return c;
  };

  // Real PLP card for one product, via the Section Rendering API on the product's own URL —
  // sections/recently-view-card.liquid is just `{% render 'product-block', product: product %}`
  // (same technique Recently Viewed uses; Similar designs does the equivalent through
  // sections/pdp-similar-designs.liquid + the recommendations endpoint).
  var fetchCard = function (p) {
    if (!p || !p.handle) return Promise.resolve(null);
    return fetch('/products/' + encodeURIComponent(p.handle) + '?section_id=recently-view-card', {
      credentials: 'same-origin'
    })
      .then(function (r) {
        return r.ok ? r.text() : '';
      })
      .then(function (html) {
        if (!html) return null;
        var node = new DOMParser().parseFromString(html, 'text/html').querySelector('.CT_product-block');
        return node ? document.importNode(node, true) : null;
      })
      .catch(function () {
        return null;
      });
  };

  var loadSimilar = function () {
    if (similarCache) return similarCache;
    if (!sku) return Promise.resolve([]);
    if (typeof window.kGetSimilarProducts !== 'function' && window.jQuery) {
      window.__kSimilarProductsRequests = window.__kSimilarProductsRequests || {};
      window.kGetSimilarProducts = function (value) {
        value = String(value || '').trim();
        if (!window.__kSimilarProductsRequests[value]) {
          window.__kSimilarProductsRequests[value] = jQuery.ajax({
            url: apiBase + '/callback/similar-products',
            data: { sku: value },
            type: 'GET',
            headers: { 'Content-Type': 'application/json' }
          });
        }
        return window.__kSimilarProductsRequests[value];
      };
    }
    var request = typeof window.kGetSimilarProducts === 'function'
      ? window.kGetSimilarProducts(sku)
      : fetch(apiBase + '/callback/similar-products?sku=' + encodeURIComponent(sku), { headers: { 'Content-Type': 'application/json' } });
    similarCache = request.then(function (response) {
      if (response && Array.isArray(response.product)) return response;
      if (!response.ok) throw new Error('Similar products request failed');
      return response.json();
    }).then(function (payload) {
      return (Array.isArray(payload.product) ? payload.product : []).filter(function (p) {
        return String(p.sku || '').trim() !== sku &&
          String(p.handle || '').trim().toLowerCase() !== String(box.dataset.productHandle || '').trim().toLowerCase() &&
          String(p.groupId || '').trim() !== currentId &&
          String(p.id || '').trim() !== String(box.dataset.variantId || '').trim();
      });
    }).catch(function () { return []; });
    return similarCache;
  };

  var load = function (handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + PER_COLLECTION, {
        credentials: 'same-origin'
      })
        .then(function (r) {
          return r.ok ? r.json() : { products: [] };
        })
        .then(function (d) {
          return (d && d.products) || [];
        })
        .catch(function () {
          return [];
        });
    }
    return cache[handle];
  };

  var handles = tagLinks.map(handleOf).filter(Boolean);
  var grid = el('div', 'pdp-explore__grid');
  // Keep the layout stable while the Similar Products API and PLP cards load.
  for (var skeletonIndex = 0; skeletonIndex < 4; skeletonIndex++) {
    var skeleton = el('div', 'pdp-explore__skeleton');
    skeleton.appendChild(el('div', 'pdp-explore__skeleton-block pdp-explore__skeleton-image'));
    skeleton.appendChild(el('div', 'pdp-explore__skeleton-block pdp-explore__skeleton-title'));
    skeleton.appendChild(el('div', 'pdp-explore__skeleton-block pdp-explore__skeleton-price'));
    grid.appendChild(skeleton);
  }
  box.appendChild(grid);
  var viewAll = el('a', 'pdp-collection-view-all', 'View All Products');
  viewAll.hidden = true;
  box.appendChild(viewAll);

  var notCurrent = function (p) {
    return p && String(p.id) !== currentId;
  };

  var productsFor = function (handle) {
    if (handle) {
      return load(handle).then(function (list) {
        return list.filter(notCurrent).slice(0, MAX_SHOWN);
      });
    }
    return Promise.all(handles.map(load)).then(function (lists) {
      var seen = {};
      var out = [];
      for (var i = 0; out.length < MAX_SHOWN; i++) {
        var any = false;
        for (var j = 0; j < lists.length && out.length < MAX_SHOWN; j++) {
          var p = lists[j][i];
          if (p) any = true;
          if (p && notCurrent(p) && !seen[p.id]) {
            seen[p.id] = true;
            out.push(p);
          }
        }
        if (!any) break;
      }
      return out;
    });
  };

  var similarProductsFor = function () {
    return loadSimilar();
  };

  var token = 0;
  var similarChip = null;
  var chips = tagLinks.slice();
  var ensureSimilarChip = function (list) {
    if (similarChip || !list.length) return;
    similarChip = el('button', 'collection-tag-pdp pdp-explore__all is-active', 'Similar Products');
    similarChip.type = 'button';
    content.insertBefore(similarChip, content.firstChild);
    chips.unshift(similarChip);
    similarChip.addEventListener('click', function () {
      if (similarChip.classList.contains('is-active')) return;
      activate(similarChip);
      show('', true);
    });
  };
  var show = function (handle, similar) {
    var mine = ++token;
    grid.classList.add('is-loading');
    (similar ? similarProductsFor() : productsFor(handle)).then(function (list) {
      if (mine !== token) return list && [];
      if (similar && !list.length) {
        var firstTag = tagLinks[0];
        if (firstTag) {
          activate(firstTag);
          show(handleOf(firstTag), false);
          return;
        }
      }
      if (similar) ensureSimilarChip(list);
      return Promise.all(list.map(fetchCard)).then(function (nodes) {
        if (mine !== token) return;
        grid.textContent = '';
        nodes.forEach(function (node, i) {
          var c = node || card(list[i]);
          if (c) grid.appendChild(c);
        });
        grid.classList.remove('is-loading');
        grid.hidden = !grid.children.length;
        var activeCollection = !similar && tagLinks.find(function (tag) {
          return handleOf(tag) === handle;
        });
        viewAll.href = activeCollection ? activeCollection.getAttribute('href') : '#';
        viewAll.hidden = similar || !grid.children.length;
        if (window.KProductCardSlider && typeof window.KProductCardSlider.init === 'function') {
          window.KProductCardSlider.init(grid);
        }
        var ids = localWishlistIds();
        if (typeof check_wishlist_added === 'function') {
          ids.forEach(function (id) {
            check_wishlist_added(id);
          });
        }
      });
    });
  };

  var activate = function (chip) {
    chips.forEach(function (c) {
      c.classList.toggle('is-active', c === chip);
    });
  };

  tagLinks.forEach(function (a) {
    a.addEventListener('click', function (event) {
      var h = handleOf(a);
      if (!h) return;
      event.preventDefault();
      if (a.classList.contains('is-active')) return;
      activate(a);
      show(h);
    });
  });

  // Defer the requests until the section is near the viewport.
  var started = false;
  var start = function () {
    if (started) return;
    started = true;
    show('', true);
  };
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) {
          io.disconnect();
          start();
        }
      },
      { rootMargin: '600px 0px' }
    );
    io.observe(box);
  } else {
    start();
  }
})();
